<template>
  <div id="app" :class="appClasses">
    <HeaderMenu :class="headerClasses"/>
    <div :class="containerClasses">
      <add-project-modal v-if="$store.getters.getUserId" :current_project="$store.state.current_project"/>
      <add-applicant-modal v-if="$store.getters.getUserId" />
      <Aside/>
      <section class="main_section" :class="mainSectionClasses">
        <b-alert :show="showAlertForEmail" variant="warning" class="text-center" id="email_valid_alert" v-html="showAlertForEmailText"></b-alert>
        <router-view/>
      </section>
      <video v-if="authRoute" loop="loop" muted="" autoplay="autoplay" class="fullscreen_auth__video">
        <source src="https://hr-crm.io/files/login_video.mp4" type="video/mp4">
      </video>
    </div>
    <FooterMenu/>
    <modal-confirm/>
    <common-info-modal/>
  </div>
</template>

<script>
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'
import Vue from 'vue'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import HeaderMenu from "./components/header-menu";
import FooterMenu from "./components/footer-menu";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ModalConfirm from "./components/common/modal-confirm";
import Aside from "./views/Aside.vue";
import AddProjectModal from "./views/projects/add-project-modal.vue";
import AddApplicantModal from "./components/modal/add-applicant-modal.vue";
import CommonInfoModal from "./components/modal/common-info-modal.vue";
import router from "./router";

var VueCookie = require('vue-cookie');

export default {
  name: 'index',
  components: {CommonInfoModal, AddApplicantModal, AddProjectModal, Aside, ModalConfirm, HeaderMenu, FooterMenu},
  data() {
    return {}

  },

  computed: {
    showAlertForEmail() {
      return this.$store.getters.getUser?.is_allowed_email === false && !['login', 'registration', 'forgot-password'].includes(this.$route.name);
    },
    showAlertForEmailText() {
      return this.$store.getters.getUser?.alert_email_txt || ''
    },
    authRoute() {
      return ['login', 'registration', 'forgot-password'].includes(this.$route.name)
    },
    appClasses() {
      if(this.$route.name === 'video-chat') return ['wch']
      else if(this.authRoute) return ['auth_layout']
      else return ['wr']
    },
    mainSectionClasses() {
      if(this.$route.name === 'applicant') return ['bg_card']
      else if(/\/settings\//i.test(this.$route.fullPath)) return ['bg_settings']
      else return []
    },
    headerClasses() {
      switch (this.$route.name) {
        case 'video-chat':
          return ['dn']
        default:
          return []
      }
    },
    containerClasses() {
      if (this.authRoute) {
        return ['authorize_container', 'container']
      } else if(this.$route.name === 'video-chat') {
        return ['video_chat_container']
      } else if(!this.$store.state.burgerExpanded) {
        return ['container', 'burger_not_expanded_white']
      } else {
        return ['container']
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('availableUser', this.availableUser)
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
      window.removeEventListener('click', this.onGlobalClick, { passive: true })
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize, { passive: true })
    window.addEventListener('click', this.onGlobalClick, { passive: true })
    // subscribe to channels
    if (!this.$store.getters.getUserId) this.$bus.$on('availableUser', this.availableUser)
    else this.availableUser(this.$store.getters.getUserId)
  },
  methods: {
    availableUser(auth_id) {
      this.$echo.listen('preserve-FrontMessages', 'AppMessagesEvent', ({data:{user_id, message, href, variant = 'Success'}}) => {
        if(auth_id === user_id) {
          const messagesBlocks = message.split('<br/>').map((txt) => {
            return this.$createElement('div', {}, [txt]);
          })
          const msg = this.$createElement('section', {}, messagesBlocks);
          this.$bvToast.toast(msg, {
            title: this.trans(`common.${variant}`),
            variant: variant?.toLowerCase(),
            solid: true,
            noAutoHide: true,
            href: href
          })
        }
      });
    },
    onGlobalClick(e) {
      if(
          (!e.target.closest('.search_result_container') || e.target.id === 'search_result_link')
          && e.target.id !== 'search_applicant_widget_input'
      ) {
        this.$bus.$emit('searchAsideCloseEmmit')
      }

    },
    onResize () {
      this.$store.commit('setMobWidth')
    },

  },

}

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueCookie)
</script>

<style lang="css">
#app {
  height: 100vh;
}

#app > .container {height: 100%; min-height: 100%; display: flex; max-width: 100% !important; padding: 0; background: var(--System-Header-bg)}
#app > .container > aside + section.main_section.bg_card {background: var(--System-card-bg)}
#app > .container > aside + section.main_section {flex: 1 1; overflow: auto; border-radius: 20px 0 0 0; min-height: 100%; background: var(--System-White);}
#app > .container > aside + section.main_section.bg_settings {overflow: hidden;}
#app > .container > aside + section.main_section::-webkit-scrollbar {display: none;}

#app.auth_layout > .container > aside + section.main_section {width: 100%; display: flex; align-items: center; justify-content: center;
  background: rgba(0,0,0,0.6);position: absolute;top:0;left:0;height: 100%;z-index: 4; border-radius: 0;}
#app.auth_layout > .container > .main_aside {display: none;}

#app > .authorize_container {overflow: hidden;position: relative;height: 100%;width: 100%;}
#app > .authorize_container > .fullscreen_auth__video {position: absolute;top: 0;left: 0;width: 100%; height: 100%; object-fit: cover;}
#app > .video_chat_container {background: unset; height: 100%;}
#app > .video_chat_container > div {height: 100%;}
#app > .video_chat_container > div > .container {max-width: unset; height: 100%;}

.wr {padding-top: 56px;}

.wch{height: 100vh;}

.card-title {text-transform: none !important;font-weight: 600 !important;}

body {font-family: 'Montserrat', sans-serif !important;}

.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {font-weight: 900 !important;}

.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {text-transform: uppercase !important;}

.td, .th, td, th {vertical-align: middle !important;padding: 7px !important;font-size: 14px !important;}

@media (max-width: 992px) {
  .wr {padding-top: 50px;}
  #app > .container {background: var(--System-White)}
  #app > .container > aside + section.main_section {border-radius: 0;}
}

</style>
